import React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import client from './apollo/client';
import './styles/tailwind.css';
import { Route, BrowserRouter } from 'react-router-dom';
import Routes from 'Routes';

console.log("02: App.js실행확인");

function App() {
  if (process.env.NODE_ENV === 'production') {
    // production 마우스 우클릭 방지
    document.addEventListener('contextmenu', (event) => event.preventDefault());
  }

  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <Route path="/" component={Routes} />
      </BrowserRouter>
    </ApolloProvider>
  );
}

export default App;